module.exports = __webpack_public_path__ + "img/logo-spotify.cc552dda.png";